// extracted by mini-css-extract-plugin
export default {"root":"style_root__zu763","title":"style_title__PDicY","actions":"style_actions__V7tRP"};